import { Component, OnInit } from '@angular/core';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardMonitoringProblemsComponent')
@Component({
  selector: 'app-wizard-monitoring-problems',
  templateUrl: './wizard-monitoring-problems.component.html',
  styleUrls: ['./wizard-monitoring-problems.component.scss']
})
export class WizardMonitoringProblemsComponent implements OnInit, DashboardWidgetContent {

  constructor() { }

  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
  }

}
